import axios from 'axios';
import header from "./header";

const baseUrl = process.env.VUE_APP_BASE_URL;
const apiV1 = process.env.VUE_APP_API_V1;
const apiV2 = process.env.VUE_APP_API_V2;

class UserService {

  getPublicContent() {
    return axios.get(`/all`)
  }

  getUserData() {
    return axios.get(`${baseUrl + apiV1}/user`, header)
  }

   getUserInfoForCheckoutData() {
      return axios.get(`${baseUrl + apiV1}/user/info-for-checkout`, header)
   }

  getResumeUserData() {
      return axios.get(`${baseUrl + apiV1}/user/resume`, header)
   }

  setSocial(data) {
    return axios.post(`${baseUrl + apiV1}/user/social/`, {data}, header);
  }

  postBankAccount(data, isBankAccoun) {
     if (!isBankAccoun) {
        return axios.post(`${baseUrl + apiV1}/user/bank-account`, {data}, header)
     }

     if (isBankAccoun) {
        return axios.patch(`${baseUrl + apiV1}/user/update-bank-account`, {data}, header)
     }

  }

  async getBankAccount() {
    const res = await axios.get(`${baseUrl + apiV1}/user/bank-account`, header)
    return res.data.bankAccount
  }

  deleteBankAccount(id) {
    return axios.patch(`${baseUrl + apiV1}/user/bank-account`, {id}, header)
  }

  setPin(data) {
    return axios.post(`${baseUrl + apiV1}/user/pin/`, data, header);
  }

  withdrawalRequests(data) {
    return axios.post(`${baseUrl + apiV1}/user/withdrawalRequests/`, data, header);
  }

  getWithdrawalRequests(perPage, page) {
     const query = `?perPage=${perPage}&page=${page}`
    return axios.get(`${baseUrl + apiV1}/user/withdrawalRequests${query}`, header)
  }

   getRatings(type, perPage, page ) {

      const query = `?perPage=${perPage}&page=${page}`

      return axios.get(`${baseUrl + apiV1}/user/ratings/${type}${query}`,  header)
   }

   postRating( payload ) {
      return axios.post(`${baseUrl + apiV1}/user/rating`, payload,  header)
   }

   getMyRatings( perPage, page ) {

      const query = `?perPage=${perPage}&page=${page}`

      return axios.get(`${baseUrl + apiV1}/user/ratings${query}`,  header)
   }

   valNumberSendCode(number) {
      return axios.post(`${baseUrl + apiV1}/user/valnumber-sendcode/`, { number }, header);
   }

   valNumberVerifyCode(code) {
      return axios.post(`${baseUrl + apiV1}/user/valnumber-verifycode/`, { code }, header);
   }

   savePhoneNumber(phone) {
      return axios.post(`${baseUrl + apiV1}/user/update-phone`,  { phone }, header);
   }

   getUser({cpf = '', email = ''}) {
      const query = `${cpf ? '?cpf=' + cpf : '?email='+ email}`
      return axios.get(`${baseUrl + apiV2}/user${query}`)
   }

   registerUser(data) {
      return axios.post(`${baseUrl + apiV1}/auth/register`, data, header)
   }

   approveDocument(docId, status, nameSpace) {
      return axios.post(`${baseUrl + apiV2}/user/approveDocument`,  {
         docId,
         status,
         nameSpace
      })
   }

   deleteUser(_id) {
      return axios.delete(`${baseUrl + apiV2}/user/deleteUser/${_id}`)
   }

   getUserVerifications(_id) {
      return axios.get(`${baseUrl + apiV2}/user/userVerifications/${_id}`)
   }


}

export default new UserService();
